import Vue from 'vue'
import Router from 'vue-router'
import ScanPage from '@/pages/ScanPage'
import ScanPageHistory from '@/pages/ScanPage-History.vue'
import DeviceList from '@/pages/ScanDeviceList.vue'
Vue.use(Router)

export default new Router({
    mode: 'hash', // 开发阶段用hash模式（无需后端配置），生产可改history
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            redirect: '/scan' // 默认跳转到扫码页面
        },
        {
            path: '/scan',
            name: 'ScanPage',
            component: ScanPage,
            props: (route) => ({
                // 路由参数映射为组件props
                deviceCode: route.query.deviceCode
            })
        },
        // 新增详情页路由
        {
            path: '/history',
            name: 'ScanPageHistory',
            component: ScanPageHistory
        },
        // 新增详情页路由
        {
            path: '/deviceList',
            name: 'deviceList',
            component: DeviceList
        },
        {
            path: '*',
            redirect: '/scan' // 404重定向
        }
    ]
})